import React, { useEffect, } from 'react';
import { useSelector } from 'react-redux';
import RaterRoute from './RaterRoute';
import './../src/rater.css'
import './../src/deltorotheme.css';

function App() {
  const useAlternateTheme = useSelector((state) => state.setThemeReducer.useAlternateTheme);  
  useEffect(() => {
    document.body.classList.remove('deltorotheme');
    document.body.classList.add(useAlternateTheme);
  }, [useAlternateTheme]);

  return (
    <>
      <RaterRoute />
    </>
  );
}

export default App;
